// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2biny","footer":"ModalError_footer__26-50"};